import {
  GoogleAuthProvider,
  getAuth,
  signInWithRedirect,
  signOut,
  // getRedirectResult,
} from "firebase/auth";

import { initializeApp } from "firebase/app";
import { getAnalytics, setUserId, logEvent } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyBmaBOAaPCG0VKfxwRuZiMz6Ja17p5Q3_g",
  authDomain: "origami-skin.firebaseapp.com",
  projectId: "origami-skin",
  storageBucket: "origami-skin.appspot.com",
  messagingSenderId: "569029957939",
  appId: "1:569029957939:web:0fb024fa637842be464646",
  measurementId: "G-ELHG0SG728",
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const auth = getAuth();
const provider = new GoogleAuthProvider();
provider.addScope("profile");
provider.addScope("email");

let g_authInfo = null;

let callbacks = [];

// getRedirectResult(auth)
//   .then((result) => {
//     // This gives you a Google Access Token. You can use it to access Google APIs.
//     const credential = GoogleAuthProvider.credentialFromResult(result);

//     const authInfo = {
//       // The signed-in user info.
//       user: result.user,
//       token: credential.accessToken,
//     };

//     saveAuthInfo(authInfo);
//   })
//   .catch((error) => {
//     // // Handle Errors here.
//     const errorCode = error.code;
//     const errorMessage = error.message;
//     console.log(`[ERROR: ${errorCode}] ${errorMessage}`);
//     // // The email of the user's account used.
//     // const email = error.customData.email;
//     // // The AuthCredential type that was used.
//     // const credential = GoogleAuthProvider.credentialFromError(error);
//     // // ...

//     loadAuthInfo();
//   });

function isLoggedIn() {
  return g_authInfo != null;
}

function login() {
  signInWithRedirect(auth, provider);
}

function logout() {
  saveAuthInfo(null);
  signOut(auth);
}

function saveAuthInfo(authInfo) {
  if (authInfo) {
    const strAuthInfo = JSON.stringify(authInfo);
    localStorage.setItem("authInfo", strAuthInfo);
  } else {
    localStorage.removeItem("authInfo");
  }

  g_authInfo = authInfo;
  notifyLoggedIn(g_authInfo);
}

// function loadAuthInfo() {
//   let authInfo = null;
//   const strAuthInfo = localStorage.getItem("authInfo");
//   if (strAuthInfo) {
//     try {
//       authInfo = JSON.parse(strAuthInfo);
//     } catch (e) {
//       console.log(e);
//     }
//   }
//   g_authInfo = authInfo;
//   notifyLoggedIn(g_authInfo);
// }

function addLoginCallback(cb) {
  callbacks.push(cb);
}

function notifyLoggedIn(authInfo) {
  for (let cb of callbacks) {
    cb(authInfo);
  }
}

function setUser(userId) {
  setUserId(analytics, userId);
}

export { addLoginCallback, login, logout, isLoggedIn, analytics, setUser, logEvent };
